import { removeDiacritics } from '../../utils/stringUtils';
/**
 * Get formData from file
 * @param csvFile
 * @returns formData
 */
export let getFormDataFromFile = (csvFile = null, language) => {
  let formData = new FormData();
  formData.append('csvFile', removeDiacritics(csvFile));

  if (!language) {
    language = navigator.language || navigator.languages[0];
    language = language.split('-')[0];
  }
  formData.append('language', language);
  return formData;
};
